import React, { useState } from "react";
import styles from "./CustomHeader.module.scss";
import FilterIconSVG from "components/SVGComponents/FilterIconSVG";
import Button from "components/UI/Button/Button";
import SearchIconSVG from "components/SVGComponents/SearchIconSVG";
import { ReactComponent as SearchClose } from "../../../images/SVG/searchClose.svg";

const CustomHeader = (props) => {
   const { openModal, setOpenModal } = props;
  
  const [searchValue, setSearchValue] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    props?.handleSearch?.(value);
  };

  const clearSearch = () => {
    setSearchValue("");
    props?.handleSearch?.("");
  };

  return (
    <div className={styles.topSection}>
      <div className={styles.filterSearch}>
        <span
          className={styles.filterButton}
          onClick={() => setOpenModal(!openModal)}
        >
          <FilterIconSVG />
        </span>
        <span className={styles.search}>
          <SearchIconSVG className={styles.searchIcon} />
          <input
            // onChange={(e) => {
            //   props?.handleSearch && props?.handleSearch(e.target.value);
            // }}
            onChange={handleChange}
            value={searchValue}
            type="text"
            placeholder="Search"
          />
          {searchValue && (
            <div className={styles.closeIcon} onClick={clearSearch}>
              <SearchClose style={{ width: "16px", height: "16px" }} />
            </div>
          )}
        </span>
      </div>
      <Button
        disabled={props?.isExporting}
        onClick={props?.handleExport}
        variant="filled"
      >
        {props?.isExporting ? "Exporting..." : "Export Excel"}
      </Button>
    </div>
  );
};

export default CustomHeader;
